import { CheckListResponseModel, CommonResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { CheckListModelEntity } from './checklist-model.entity';
import { CheckListModelAdapter } from './dto/checklist-model.adapter';
import { CheckListModelDTO } from './dto/checklist-model.dto';

import { ErrorResponse } from '@gtpl/shared-models/common-models';
// import {LogsService} from '.shared-services/user-logs/src/lib/user-logs-service';
@Injectable()
export class CheckListModelService {
  constructor(
    private logService: LogsService,
    @InjectRepository(CheckListModelEntity)
    private checklistmodelRepository: Repository<CheckListModelEntity>,
    private checklistmodelAdapter: CheckListModelAdapter,
  ) { }

  async getChecklistWithoutRelations(checkList: string): Promise<CheckListModelEntity> {
    // tslint:disable-next-line: typedef
    const CheckListResponseModel = await this.checklistmodelRepository.findOne({
      where: { checkList: Raw(alias => `check_list = '${checkList}'`) },
    });
    if (CheckListResponseModel) {
      return CheckListResponseModel;
    } else {
      return null;
    }
  }

  async createChecklist(ChecklistmodelDto: CheckListModelDTO, isUpdate: boolean): Promise<CheckListResponseModel> {
    console.log(ChecklistmodelDto);
    try {
      const existingRec = await this.checklistmodelRepository.findOne({ where: { checkList: ChecklistmodelDto.checkList } });

      if (existingRec && existingRec.checkList === ChecklistmodelDto.checkList) {
        throw new ErrorResponse(23, "This record already exists");
      }

      const internalMessage = isUpdate ? "Checklist updated successfully" : "Checklist created successfully";
      const convertedData = this.checklistmodelAdapter.convertDtoToEntity(ChecklistmodelDto);
      await this.checklistmodelRepository.save(convertedData);
      return new CommonResponse(true, 343, internalMessage);
    } catch (error) {
      throw new ErrorResponse(333, error.message);
    }
  }

  async getAllChecklists(): Promise<CommonResponse> {
    const records = await this.checklistmodelRepository.find({ select: ['checkListId', 'checkList'], });
    if (!records.length) {
      throw new ErrorResponse(998, 'No Records Found');
    }
    return new CommonResponse(true, 56, 'CheckList data retrieved SuccessFully', records);
  }

  async getAllCheckListDropDown(): Promise<CommonResponse> {
    const records = await this.checklistmodelRepository.find({ select: ['checkListId', 'checkList'], });
    if (!records.length) {
      throw new ErrorResponse(99998, 'No Records Found');
    }
    return new CommonResponse(true, 53, 'CheckList data retrieved SuccessFully', records);
  }

  async deleteCheckList(ChecklistmodelDto: CheckListModelDTO): Promise<CheckListResponseModel> {
    console.log(ChecklistmodelDto);
    try {
      const existingRec = await this.checklistmodelRepository.findOne({ where: { checkListId: ChecklistmodelDto.checkListId } });
      if (!existingRec) {
        throw new ErrorResponse(23, "No record found")
      }
      await this.checklistmodelRepository.delete(existingRec);
      return new CommonResponse(true, 343, "Deleted successfully");
    } catch (error) {
      throw new ErrorResponse(333, error.message);
    }
  }
}
